@if (isLoaderDisplayed$ | async) {
  <div class="wrapper flex flex-column justify-center items-center h-full w-full absolute bg-navy-30 z-50">
    <app-loading-animation class="h-auto" width="270px" height="270px"></app-loading-animation>
    @if (isLongLoading$ | async) {
      <div class="long-loading-text font-main text-2xl text-navy-90">
        {{ buildTranslationKey('longLoadingText') | translate }}
      </div>
    }
  </div>
}
